import React from 'react';
export function WhatIsIncluded() {
  const books = [{
    title: 'Fondamenti dell’Educazione Fisica Moderna',
    desc: 'Metodi, strategie didattiche e organizzazione delle lezioni.',
    color: 'bg-blue-50 border-blue-200 text-blue-900'
  }, {
    title: 'Giochi di Movimento per la Scuola',
    desc: 'Attività divertenti e coinvolgenti per sviluppare abilità motorie.',
    color: 'bg-green-50 border-green-200 text-green-900'
  }, {
    title: 'Percorsi Psicomotori per Insegnare',
    desc: 'Percorsi e attività per coordinazione, equilibrio e orientamento.',
    color: 'bg-orange-50 border-orange-200 text-orange-900'
  }, {
    title: 'Sport e Attività Pre-Sportive per la Scuola',
    desc: 'Esercizi pratici per introdurre gli sport in modo semplice.',
    color: 'bg-purple-50 border-purple-200 text-purple-900'
  }, {
    title: 'Pianificazione delle Lezioni e Valutazione',
    desc: 'Strumenti per organizzare l’insegnamento e monitorare i progressi.',
    color: 'bg-red-50 border-red-200 text-red-900'
  }];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-219">
          Cosa ricevi esattamente all’interno del Mega-Pack
        </h2>

        <div className="space-y-4" data-id="element-220">
          {books.map((book, idx) => <div key={idx} className={`p-6 rounded-2xl border-2 ${book.color} shadow-sm flex flex-col md:flex-row items-start md:items-center gap-4 transition-transform hover:-translate-y-1`} data-id="element-221">
              <div className="bg-white/60 rounded-full w-12 h-12 flex items-center justify-center font-bold text-xl flex-shrink-0" data-id="element-222">
                {idx + 1}
              </div>
              <div data-id="element-223">
                <h3 className="text-xl font-bold mb-1" data-id="element-224">{book.title}</h3>
                <p className="opacity-80 font-medium" data-id="element-225">{book.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}